import React from 'react';
import { IAbilities, IAuth, IOrganizationStore, IJourneyStore, } from '@Store';
import { CrudEnum, IPreviewJourneyTrigger, PermissionEnum, TJourneyTriggerSortableListCol, } from 'atlas-shared';
import { tableColumnDatetimeSorter, timeSince, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { listAuditButton, GetColumnSearchProps, GetColumnSearchEqualProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const JourneyTriggerListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, organizations: IOrganizationStore, journeies: IJourneyStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewJourneyTrigger) => React.ReactElement> = [], filters: IWithListProps<IPreviewJourneyTrigger, TJourneyTriggerSortableListCol>['filters'], sorter: IWithListProps<IPreviewJourneyTrigger, TJourneyTriggerSortableListCol>['sorter']): ColumnsType<IPreviewJourneyTrigger> => {
  return [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      sorter: (a: IPreviewJourneyTrigger, b: IPreviewJourneyTrigger) => a.id - b.id,
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'id')?.order || null,
      filteredValue: filters.id || null,
      ...GetColumnSearchEqualProps(t, 'id', t('ID')),
      className: 'table-cell-id',
    },
    auth.user.__admin_organization_ids.length > 1 && {
      title: t('ORGANIZATION'),
      dataIndex: 'organization_id',
      key: 'organization_id',
      render: (organization_id: IPreviewJourneyTrigger['organization_id'], journey_trigger: IPreviewJourneyTrigger) => organizations.dict?.[organization_id]?.title || t('ORGANIZATION_NOT_FOUND', { replace: { organization_id, }, }),
      sorter: (a: IPreviewJourneyTrigger, b: IPreviewJourneyTrigger) => (organizations.dict?.[a.organization_id]?.title || '').localeCompare(organizations.dict?.[b.organization_id]?.title || ''),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'organization_id')?.order || null,
      filteredValue: filters.organization_id || null,
      ...GetColumnSearchProps(t, 'organization_id', t('ORGANIZATION'), organizations.organizations),
      className: 'table-cell-organization_id',
    },
    {
      title: t('JOURNEY'),
      dataIndex: 'journey_id',
      key: 'journey_id',
      render: (journey_id: IPreviewJourneyTrigger['journey_id'], journey_trigger: IPreviewJourneyTrigger) => journeies.dict?.[journey_id]?.title || t('JOURNEY_NOT_FOUND', { replace: { journey_id, }, }),
      sorter: (a: IPreviewJourneyTrigger, b: IPreviewJourneyTrigger) => (journeies.dict?.[a.journey_id]?.title || '').localeCompare(journeies.dict?.[b.journey_id]?.title || ''),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'journey_id')?.order || null,
      className: 'table-cell-journey_id',
    },
    {
      title: t('CREATED_AT'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: IPreviewJourneyTrigger['created_at'], journey_trigger: IPreviewJourneyTrigger) => <div className='date-column'>{created_at ? timeSince(t, new Date(created_at), true) : ''}</div>,
      sorter: (a: IPreviewJourneyTrigger, b: IPreviewJourneyTrigger) => tableColumnDatetimeSorter(a.created_at, b.created_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'created_at')?.order || null,
      className: 'table-cell-created_at',
    },
    
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewJourneyTrigger) => (
        <div className={'table-operation-wrp'}>
          {buttons.map(button => button(row))}
          {abilities.can(row.organization_id, CrudEnum.Read, PermissionEnum.Audit, row) && listAuditButton(t, navigate, 'journey_trigger', row)}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewJourneyTrigger>;

};
